import { useRecoilState, useRecoilValue } from "recoil";
import { DialogWrapper } from "./style";
import { customDialogState } from "../../recoil/custom-dialog.atom";
import { WideState } from "../../recoil/wide";

const CustomDialog = () => {
  const [dialog, setDialog] = useRecoilState(customDialogState);
  const isWide = useRecoilValue(WideState);

  if (!dialog) {
    return <></>;
  }
  return (
    <DialogWrapper isWide={isWide}>
      <div className="title">{dialog.title}</div>
      <div className="buttons">
        <div
          className={`${dialog.confirmColor ? dialog.confirmColor : "purple"}`}
          onClick={async () => {
            if (dialog.confirm) {
              await dialog.confirm();
            }
            setDialog(null);
          }}
        >
          {dialog.confirmText ? dialog.confirmText : "예"}
        </div>
        <div
          className={`${dialog.confirmColor ? dialog.confirmColor : "white"}`}
          onClick={() => (dialog.cancel ? dialog.cancel() : setDialog(null))}
        >
          {dialog.cancelText ? dialog.cancelText : "아니오"}
        </div>
      </div>
    </DialogWrapper>
  );
};

export default CustomDialog;
